<template>
  <div
    v-on-clickaway:mousedown="handleClickAway"
    class="acv-legacy-dropdown"
    :class="{ 'acv-legacy-dropdown--right': align === 'right', 'acv-legacy-dropdown--left': align === 'left' }"
  >
    <div class="acv-legacy-dropdown__trigger">
      <slot
        name="trigger"
        :toggle="toggle"
        :show="show"
        :hide="hide"
        :is-open="isOpen"
      />
    </div>
    <div
      v-if="isOpen"
      class="acv-legacy-dropdown__panel"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineOptions({
  name: 'AcvLegacyDropdown',
});

defineProps({
  /**
   * Which side of the trigger the panel aligns to.
   */
  align: {
    type: String,
    default: 'left',
    validator: (value) => ['left', 'right'].includes(value),
  },
});

const emit = defineEmits(['opened', 'closed', 'shown', 'hidden']);

const isOpen = ref(false);

function show() {
  if (isOpen.value) return;
  isOpen.value = true;
  emit('opened');
  emit('shown');
}

function hide() {
  if (!isOpen.value) return;
  isOpen.value = false;
  emit('closed');
  emit('hidden');
}

function toggle() {
  if (isOpen.value) {
    hide();
  } else {
    show();
  }
}

function handleClickAway() {
  hide();
}

defineExpose({
  show,
  hide,
  toggle,
});
</script>

<style lang="scss" scoped>
.acv-legacy-dropdown {
  position: relative;
  display: inline-block;

  &__trigger {
    display: inline-flex;
  }

  &__panel {
    position: absolute;
    top: 100%;
    z-index: 1000;
    margin-top: 0.25rem;
  }

  &--left {
    .acv-legacy-dropdown__panel {
      left: 0;
    }
  }

  &--right {
    .acv-legacy-dropdown__panel {
      right: 0;
    }
  }
}
</style>
